export enum DocumentExpirationErrorCodes {
	UserDocumentExpirationDateExpired = 400241,
	UserDocumentExpirationDateNotSet = 400258,
}
